import type { ImageSourcePropType } from 'react-native'
import type { StableBotProfile } from '@warcarp/api-types'

/**
 * Static asset map for the stable bot roster. Keeping each require literal is
 * intentional: Metro and Expo web can discover these assets at build time.
 */
const BOT_AVATARS: Record<StableBotProfile, ImageSourcePropType> = {
  hannibal: require('../assets/bots/hannibal.webp') as ImageSourcePropType,
  'sun-tzu': require('../assets/bots/sun-tzu.webp') as ImageSourcePropType,
  boudica: require('../assets/bots/boudica.webp') as ImageSourcePropType,
  zenobia: require('../assets/bots/zenobia.webp') as ImageSourcePropType,
  genghis: require('../assets/bots/genghis.webp') as ImageSourcePropType,
  tamerlane: require('../assets/bots/tamerlane.webp') as ImageSourcePropType,
  caesar: require('../assets/bots/caesar.webp') as ImageSourcePropType,
  artemisia: require('../assets/bots/artemisia.webp') as ImageSourcePropType,
}

export function botAvatarFor(profile: string): ImageSourcePropType | null {
  return profile in BOT_AVATARS
    ? BOT_AVATARS[profile as StableBotProfile]
    : null
}
